// vendors
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProjectLocationsInitialState } from './project-locations.state';

// 1. Get the whole feature state
export const selectProjectLocationsState =
  createFeatureSelector<ProjectLocationsInitialState>('project_locations');

// 2. Individual selectors
export const selectProjectLocations = createSelector(
  selectProjectLocationsState,
  (state: ProjectLocationsInitialState) => state.projectLocations
);
